import { z } from "zod"

export const LocationTypeEnum = z.enum(["own", "rented", "extern"], {
  message: "Locatie type is verplicht",
})

export type LocationType = z.infer<typeof LocationTypeEnum>
export type LocationCoffeeTeaOption = z.infer<typeof LocationCoffeeTeaEnum>

export const LocationCoffeeTeaEnum = z.enum(
  ["none", "available_paid", "free"],
  {
    message: "Koffie/thee voorziening is verplicht",
  },
)

export const locationTypeOptions: {
  value: LocationType
  label: string
}[] = [
  { value: "own", label: "Eigen pand" },
  { value: "rented", label: "Gehuurd pand" },
  { value: "extern", label: "Extern pand" },
]

export const locationTypeMap: Record<LocationType, string> = {
  own: "Eigen pand",
  rented: "Gehuurd pand",
  extern: "Extern pand",
}

export const locationCoffeeTeaOptions: {
  value: LocationCoffeeTeaOption
  label: string
}[] = [
  { value: "none", label: "Geen" },
  { value: "available_paid", label: "Beschikbaar (betaald)" },
  { value: "free", label: "Gratis beschikbaar" },
]

export const locationCoffeeTeaMap: Record<LocationCoffeeTeaOption, string> = {
  none: "Geen",
  available_paid: "Beschikbaar (betaald)",
  free: "Gratis beschikbaar",
}
